import { render, staticRenderFns } from "./ChartCanvas.vue?vue&type=template&id=24004880&scoped=true"
import script from "./ChartCanvas.vue?vue&type=script&lang=js"
export * from "./ChartCanvas.vue?vue&type=script&lang=js"
import style0 from "./ChartCanvas.vue?vue&type=style&index=0&id=24004880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24004880",
  null
  
)

export default component.exports